import path from 'path';

/** Electron specific modules that will fail for static html site */

export const electron = window.require
  ? window.require("electron")
  : null;

export const child = electron
  ? window.require("child_process")
  : null;

export const process = electron
  ? window.require("process")
  : null;

export const remote = electron?.remote;
export const shell = electron?.shell;
export const ipcRenderer = electron?.ipcRenderer;
export const dialog = remote?.dialog;
export const app = remote?.app;
export const getCurrentWindow = remote?.getCurrentWindow;
export const Menu = remote?.Menu;
export const fs = remote?.require('fs');
export const fse = remote?.require('fs-extra');
export const csv = remote?.require('fast-csv');
export const glob = remote?.require('glob');
export const isStaticSite = !electron;

export const storage = electron
  ? remote.require('electron-json-storage-sync')
  : null;

export const isDevMode = remote
  ? (app.isPackaged === false)
  : false;

export const tempDirectoryPath = app
  ? path.join(app.getPath('userData'), "temp")
  : null;

export const tempPointsPath = app
  ? path.join(app.getPath('userData'), "temp", "points")
  : null;

export const logDirectoryPath = app
  ? path.join(app.getPath('userData'), "logs")
  : null;

export const storageDirectoryPath = app
  ? path.join(app.getPath('userData'), "storage")
  : null;

export const getTempFilePath = (filename) => {
  return path.join(tempDirectoryPath, filename);
};

const clearTemporaryPoints = async () => {
  if (isStaticSite) return;

  const filenames = await fse.readdir(tempPointsPath);

  for (let filename of filenames) {
    const filePath = path.join(tempPointsPath, filename);
    const stats = await fse.stat(filePath);
    const currentDate = Date.now();
    const oneHourSeconds = 3600;
    const timeElapsed = (currentDate - stats.birthtimeMs)/1000;

    if (timeElapsed > oneHourSeconds) {
      fse.remove(filePath);
    }
  }
};

const createInitialFolders = () => {
  if (isStaticSite) return;

  if (!fs.existsSync(tempDirectoryPath)) {
    console.log("Creating temporary file folder...");
    fs.mkdirSync(tempDirectoryPath);
  }

  if (!fs.existsSync(tempPointsPath)) {
    console.log("Creating temporary points folder...");
    fs.mkdirSync(tempPointsPath);
  }

  if (!fs.existsSync(logDirectoryPath)) {
    console.log("Creating log output folder...");
    fs.mkdirSync(logDirectoryPath);
  }
};

createInitialFolders();
clearTemporaryPoints();
